import {NgModule} from '@angular/core';
import {FieldPipe} from 'src/pipes/field.pipe';
import {FileSizePipe} from 'src/pipes/filesize.pipe';
import {LocalDatePipe} from 'src/pipes/localdate.pipe';
import {SafePipe} from 'src/pipes/safe.pipe';
import {InvoiceAppearancePipe} from 'src/pipes/invoice-appearance.pipe';
import {InvoiceCategoryPipe} from 'src/pipes/invoice-category.pipe';
import {InvoiceStatusPipe} from 'src/pipes/invoice-status.pipe';
import {ConventionalInfoDataTypePipe} from 'src/pipes/conventionalinfo-datatype.pipe';
import {CasePipe} from 'src/pipes/case.pipe';
import {ReplacePipe} from 'src/pipes/replace.pipe';
import {RuntimeStatusPipe} from 'src/pipes/runtime-status.pipe';

const pipes = [
    CasePipe,
    ConventionalInfoDataTypePipe,
    FieldPipe,
    FileSizePipe,
    InvoiceAppearancePipe,
    InvoiceCategoryPipe,
    InvoiceStatusPipe,
    LocalDatePipe,
    ReplacePipe,
    RuntimeStatusPipe,
    SafePipe,
];

@NgModule({
    imports: [],
    declarations: pipes,
    exports: pipes
})
export class SharedPipesModule { }
